import {Routes} from '@angular/router';
import {environment} from '../environments/environment';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home').then(m => m.Home),
    title: `Inicio | ${environment.title}`,
    data: { description: environment.seoDescription }
  },
  {
    path: 'catalog',
    loadComponent: () => import('./pages/catalog/catalog').then(m => m.Catalog),
    title: `Catálogo de Productos | ${environment.title}`,
    data: { description: `Explora el catálogo completo de ${environment.title}. Encuentra los productos de farmacia que necesitas.` }
  },
  {
    path: 'product/:id',
    loadComponent: () => import('./pages/product/product').then(m => m.Product),
    title: `Producto | ${environment.title}`
  },
  {
    path: 'checkout',
    loadComponent: () => import('./pages/checkout/checkout').then(m => m.Checkout),
    title: `Checkout | ${environment.title}`
  },
  {
    path: 'track-order',
    loadComponent: () => import('./pages/track-order/track-order').then(m => m.TrackOrder),
    title: `Seguimiento de Pedido | ${environment.title}`
  },
  {
    path: 'track-order/:id',
    loadComponent: () => import('./pages/track-order/track-order').then(m => m.TrackOrder),
    title: `Seguimiento de Pedido | ${environment.title}`
  }
];
